// src/components/MiaFirma.js
// La firma salvata del tecnico (utils/firmaSalvata.js):
//  • UsaMiaFirma: accanto a «firma del tecnico» nei moduli, mette la firma con un tocco
//    (o, se non è ancora salvata, la fa salvare una volta e la mette subito);
//  • CardMiaFirma: nelle Impostazioni → Profilo, per vederla, cambiarla o eliminarla.
import React, { useState } from "react";
import FirmaPad, { FirmaImmagine } from "./FirmaPad";
import { useMiaFirma } from "../utils/firmaSalvata";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../utils/Toast";
import { confirm } from "../utils/confirm";
import { messaggioErrore } from "../utils/erroriUtente";

const stileBtn = (pieno) => ({
  padding: "7px 14px", borderRadius: 7, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Inter',sans-serif",
  border: "1px solid #7c3aed", background: pieno ? "#7c3aed" : "#fff", color: pieno ? "#fff" : "#7c3aed",
});

/** Pulsante «Usa la mia firma». onUsa(dataUrl). */
export function UsaMiaFirma({ onUsa, style }) {
  const { firma, caricata, salva } = useMiaFirma();
  const { currentUser } = useAuth();
  const { addToast } = useToast();
  const [salvaNuova, setSalvaNuova] = useState(false);
  if (!caricata) return null;
  const nome = currentUser?.displayName ? ` (${currentUser.displayName})` : "";
  if (firma) {
    return <button type="button" onClick={() => onUsa(firma)} style={{ ...stileBtn(true), ...style }}>✍️ Usa la mia firma{nome}</button>;
  }
  if (salvaNuova) {
    return (
      <div style={{ marginTop: 8, ...style }}>
        <FirmaPad label="La mia firma — si salva per le prossime volte"
          onSave={async d => {
            try { await salva(d); addToast("Firma salvata: le prossime volte basta un tocco ✅", "success"); }
            catch (e) { addToast(messaggioErrore(e, "salvare la firma"), "error"); }
            onUsa(d); setSalvaNuova(false);
          }}
          onCancel={() => setSalvaNuova(false)} />
      </div>
    );
  }
  return (
    <button type="button" onClick={() => setSalvaNuova(true)} title="Firmi una volta: la firma resta salvata e la vedi solo tu"
      style={{ ...stileBtn(false), ...style }}>✍️ Salva la mia firma e usala</button>
  );
}

/** Riquadro «La mia firma» per le Impostazioni → Profilo. */
export function CardMiaFirma() {
  const { firma, caricata, salva, elimina } = useMiaFirma();
  const { addToast } = useToast();
  const [modifica, setModifica] = useState(false);
  return (
    <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: 20, marginBottom: 16 }}>
      <h3 style={{ fontSize: 14, fontWeight: 700, marginBottom: 6 }}>✍️ La mia firma</h3>
      <p style={{ fontSize: 12, color: "#6b7280", margin: "0 0 12px", lineHeight: 1.5 }}>
        Salvala una volta: nei rapportini, negli interventi di manutenzione e nel giornale di cantiere la metti come
        firma del tecnico con un tocco su «Usa la mia firma». La vedi e la usi solo tu. La firma del cliente si raccoglie sempre sul momento.
      </p>
      {!caricata ? null : modifica ? (
        <FirmaPad label="La mia firma"
          onSave={async d => {
            try { await salva(d); addToast("Firma salvata ✅", "success"); setModifica(false); }
            catch (e) { addToast(messaggioErrore(e, "salvare la firma"), "error"); }
          }}
          onCancel={() => setModifica(false)} />
      ) : firma ? (
        <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, padding: 8, background: "#fff" }}>
            <FirmaImmagine src={firma} alt="La mia firma" style={{ maxWidth: 260, maxHeight: 90, display: "block" }} />
          </div>
          <button type="button" onClick={() => setModifica(true)} style={stileBtn(false)}>Rifai la firma</button>
          <button type="button" onClick={async () => {
            if (!await confirm("Eliminare la firma salvata? Le firme già messe nei documenti restano.", { type: "danger", confirmLabel: "Elimina" })) return;
            try { await elimina(); addToast("Firma eliminata", "info"); } catch (e) { addToast(messaggioErrore(e, "eliminare la firma"), "error"); }
          }} style={{ ...stileBtn(false), borderColor: "#fca5a5", color: "#dc2626" }}>Elimina</button>
        </div>
      ) : (
        <button type="button" onClick={() => setModifica(true)} style={stileBtn(true)}>✍️ Salva la mia firma</button>
      )}
    </div>
  );
}
